// extracted by mini-css-extract-plugin
export default {"hero_heading":"styles_hero_heading__sIiJN"};